/**
 * dealCreateLinks.ts — §25 L-11a: the fan-out is VISIBLE. A deal create may
 * link the tenant's unlinked contacts whose company text byte-matches the
 * deal's account name (the server does it inside the create's transaction and
 * names them on the response). The UI SAYS so, with the names — a silent write
 * to records the user is not looking at is the thing L-11 must not become.
 * Pure (vitest pins it).
 */
import type { SalesLinkedContact } from '../../../../api/types'

/** '' when nothing was linked (the common case) or on a pre-L-11 wire. */
export function linkedContactsSentence(linked: SalesLinkedContact[] | undefined, accountName: string): string {
  if (!linked || linked.length === 0) return ''
  const n = linked.length
  const names = linked.map(c => c.fullName).join(', ')
  return `${n} ${n === 1 ? 'contact' : 'contacts'} linked to ${accountName}: ${names}`
}
